module.exports = __webpack_public_path__ + "media/images/ckb-n-72dbf1b4ed1a034e7019884c304fec78.png";